

export const About = () => {
  return (
    <div className="px-1 bg-zinc-900 transition-all duration-500 dark:bg-slate-100 min-h-screen">
      <div className="pt-6 px-4 md:pt-20 md:px-16">
        <h1 className="text-white dark:text-black text-5xl my-10 md:text-7xl text-center font-serif" data-aos="zoom-in" data-aos-duration="800" data-aos-once="true">Who am I?</h1>
        <div className="flex-wrap md:flex md:flex-nowrap justify-evenly gap-5 mt-5 transition-all duration-500" data-aos="fade-up" data-aos-duration="800" data-aos-once="true">
          <img src="/img/me-min.jpg" alt="" className="w-96 md:w-96 mx-auto md:mx-0 rounded-lg object-cover object-right" />
          <p className="mt-5 md:mt-0 text-[#e3e3e3] dark:text-black text-2xl font-light md:w-[50%]" >
            I'm a front-end developer passionate about creating beautiful and functional web experiences. <br /> <br />

            I believe great design is at the heart of every user experience. I analyze interfaces and structures daily, ensuring my projects are intuitive, visually engaging, and user-focused. <br /> <br />

            When I'm not coding, I'm constantly learning—tech-related or not.</p>
        </div>
      </div>
    </div >
  )
}
